import React, {Component} from 'react';
import {authService} from "../../../auth";
import DatePicker from "react-datepicker";
import ReadMoreReadLess from "../../../commons/ReadMoreReadLess";
import mappingUtils from "../../../project/component/commons/utils/mappingUtils";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import {Scrollbars} from 'react-custom-scrollbars';
import $ from "jquery";
import {convertUnicode, getCDNUrl, userAgentGetData} from "../../../commons/CommonFunctions";
import "react-datepicker/dist/react-datepicker.css";

class OtherExperiencePopUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated(),
            updateExperienceData: {},
            country: '',
            state: '',
            city: '',
            pagination: false,
            pageNo: 0,
            pageSize: 10,
            personalExperience: [],
            thresholdHeight: 400,
        }
    }

    componentDidMount() {
        this.getExperience();
    }

    fetchMoreData = () => {
        this.setState({isExperienceResultLoading: true, pageNo: this.state.pageNo + 1}, () => {
            this.getExperience();
        })

    };


    getExperience = () => {
        let url = '';
        if(this.state.loginSuccess){
            url = process.env.REACT_APP_userServiceURL + '/profile/get/experience?id=' + this.props.userId +
                "&page=" + this.state.pageNo + "&size=" + this.state.pageSize + userAgentGetData();
        }else{
            url = process.env.REACT_APP_userServiceURL + '/unauth/get/experience?id=' + this.props.userId +
                "&page=" + this.state.pageNo + "&size=" + this.state.pageSize;
        }
        axios({
            method: 'get',
            url: url,
            headers: {'Content-Type': 'application/json'},
            withCredentials: this.state.loginSuccess
        }).then(response => {
            if (response && response.data && response.data.body && response.data.body.experience && response.data.message === 'Success!') {
                let personalExperience = this.state.personalExperience;
                personalExperience.push(...response.data.body.experience.content);
                this.setState({
                    'personalExperience': personalExperience,
                    'pagination': !response.data.body.experience.last,
                    isResultLoading: false
                });
                let personalExperienceHeight = $("#scrollableDiv").height();
                if (personalExperienceHeight && personalExperienceHeight > 0) {
                    if (!this.state.initialThresholdHeight) {
                        this.setState({
                            initialThresholdHeight: personalExperienceHeight,
                            thresholdHeight: personalExperienceHeight * 0.6,
                        });
                    }
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    getStateList = () => {
        return (
            <div className="form-group">
                <select
                    name="state"
                    disabled={this.state.managedType === 'View more'}
                    className="form-control custom-input"
                    style={{backgroundPosition: '90% center'}}
                    required={true}
                >
                    <option selected>{this.state.state}</option>
                </select>
            </div>
        );
    };
    getCountryList = () => {
        return (
            <select
                name="country"
                disabled={this.state.managedType === 'View more'}
                className="form-control"
                style={{backgroundPosition: '90% center'}}
                required={true}>
                <option selected>{this.state.country}</option>
            </select>
        );
    };

    getCitiesList = () => {
        return (
            <div className="form-group">
                <select
                    name="city"
                    disabled={this.state.managedType === 'View more'}
                    className="form-control custom-input"
                    style={{backgroundPosition: '90% center'}}
                    required={true}>
                    <option selected>{this.state.city}</option>
                </select>
            </div>
        );
    };

    handleCurrentExperience = (data, managedType) => {
        this.setState({
            updateExperienceData: data,
        }, () => {
            if (this.state.updateExperienceData.noOfDays === 0) {
                const {updateExperienceData} = this.state;
                updateExperienceData.noOfDays = ''
                this.setState({updateExperienceData})
            }
        });
        this.setState({
            managedType: managedType
        });
        this.setState({country: data.location.country});
        this.setState({state: data.location.state});
        this.setState({city: data.location.city});

    }

    getOptimizedImage(personalInfo) {
        if (personalInfo.resizedImages && personalInfo.resizedImages['300x300'] != null) {
            return personalInfo.resizedImages['300x300'];
        }
        return personalInfo.coverImageUrl;
    }

    render() {
        return (
            <div id="other-prof-expierence-pop"
                 className={"tab-pane fade  " + (this.props.isShow === true && 'active show')} ref={(ref) => this.scrollParentRef = ref} style={{height:'100%', overflow:"auto"}}>
                <Scrollbars
                    className={'profexprow'}
                    autoHide
                    autoHeight
                    autoHeightMin={0}
                    autoHeightMax={505}
                    universal={true}
                    renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
                    renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                >
                    {this.state.personalExperience && this.state.personalExperience.length > 0 && (
                        <InfiniteScroll
                            //element="ul"
                            loadMore={this.fetchMoreData}
                            threshold={this.state.thresholdHeight}
                            useWindow={false}
                            getScrollParent={() => this.scrollParentRef}
                            hasMore={
                                !this.state.isExperienceResultLoading && !this.state.pagination
                            }
                        >
                            <div>
                                {this.state.personalExperience && this.state.personalExperience.map((data, index) => {
                                    return <div className="profexpblk">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="profexpcompany">
                                                    <figure className="complogo"><img
                                                        src={data && data.coverImageUrl ? getCDNUrl(this.getOptimizedImage(data)) : 'https://cdn.dscovr.com/images/project-default-100.webp'} onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/project-default-100.png"}}
                                                        alt=""/>
                                                    </figure>
                                                    <div>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <h5>{convertUnicode(data.title)}</h5>
                                                                <p>{data.companyName}
                                                                    <span>{mappingUtils.getEmploymentType(data.employmentType)}</span>
                                                                </p>
                                                            </div>
                                                            <div className="col-md-5 text-right">
                                                                <div className="profexptime">
                                                                    <strong>{data.type}</strong> - {new Date(data.startTime).toLocaleDateString('en-GB', {
                                                                    day: '2-digit', month: 'short', year: 'numeric'
                                                                }).replace(/ /g, '-')} -
                                                                    {mappingUtils.getEndDateCustomForExperience(data.endTime)}
                                                                </div>
                                                                <span>{data.location.city}, {data.location.state}, {data.location.country}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="profexpcomppostinfo">
                                                    <ReadMoreReadLess id={data.id+'3435'}
                                                                      description={convertUnicode(data.description)} line='3'/>
                                                    {/* <a href="#updateExpiriencepop" data-toggle="modal" onClick={event => this.handleCurrentExperience(data, 'View more')}>read more</a> */}
                                                </div>
                                                {mappingUtils.checkEmptyWebsite(data.website) &&
                                                <a onClick={(event) => window.open(mappingUtils.sanitize(data.website), "_blank")}
                                                   href="javascript:void(0)" className="web"><i
                                                    className="iExport"></i> website</a>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                })}

                                {this.state.pagination &&
                                <div className="btnblock"><a href="javascript:void(0)"
                                                             className="btn" onClick={this.fetchMoreData}>Show
                                    More</a></div>
                                }
                            </div>
                        </InfiniteScroll>
                    )}
                </Scrollbars>
                <div id="experiencePopup" className="modal fade dgpopup">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">

                                <div className="addendorsepop addExpirience">
                                    <h4> Experience</h4>
                                    <form action="">
                                        <ul id="tabs" className="nav">{this.state.updateExperienceData.type === 'JOB' ?
                                            <li className="nav-item"><a href="javascript:void(0)"
                                                                        disabled={this.state.managedType === 'View more'}
                                                                        data-target="#tabJob" data-toggle="tab"
                                                                        className="nav-link active">Job</a></li> :
                                            <li className="nav-item"><a href="javascript:void(0)"
                                                                        disabled={this.state.managedType === 'View more'}
                                                                        data-target="#tabJob"
                                                                        data-toggle="tab"
                                                                        className="nav-link">Assignment</a></li>}
                                        </ul>
                                        <div id="tabsContent" className="tab-content">
                                            <div id="tabJob" className="tab-pane fade active show">
                                                <div className="row">
                                                    <div className="col-md-12">

                                                        <div className="form-group"
                                                             style={{maxWidth: '300px', margin: '0 auto 20px'}}>
                                                            <input type="text" className="form-control custom-input"
                                                                   disabled={this.state.managedType === 'View more'}
                                                                   value={this.state.updateExperienceData.title}
                                                                   placeholder="Job Title"/>
                                                        </div>


                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="01">Company
                                                                Name </label>
                                                            <input type="text" className="form-control custom-input"
                                                                   disabled={this.state.managedType === 'View more'}
                                                                   value={this.state.updateExperienceData.companyName}
                                                                   placeholder="Write here..." name="01" required/>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="01">Company
                                                                Website </label>
                                                            <input type="text" className="form-control custom-input"
                                                                   disabled={this.state.managedType === 'View more'}
                                                                   value={this.state.updateExperienceData.website}
                                                                   placeholder="https://" name="01"/>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="01">Brief
                                                                Description </label>
                                                            <textarea name="" id=""
                                                                      disabled={this.state.managedType === 'View more'}
                                                                      className="form-control custom-input"
                                                                      value={this.state.updateExperienceData.description}
                                                                      placeholder="Write here..."></textarea>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="01">Job
                                                                Location </label>
                                                            <div className="row joblocaselect">
                                                                <div className="col-md-4 selectlist">
                                                                    {this.getCountryList()}
                                                                </div>
                                                                <div className="col-md-4 selectlist">
                                                                    {this.getStateList()}
                                                                </div>
                                                                <div className="col-md-4 selectlist">
                                                                    {this.getCitiesList()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group pfedit">
                                                            <label htmlFor="">Duration/Tenure <span>(Specify dates or days)</span></label>
                                                            <div className="row">
                                                                <div className="col-md-7 selectlist d-flex globalDTWrap common">
                                                                    <DatePicker
                                                                        className={"form-control"}
                                                                        disabled={this.state.managedType === 'View more'}
                                                                        dateFormat={"dd-MMM-yyyy"}
                                                                        selected={this.state.updateExperienceData.startTime}
                                                                    />
                                                                    <span>To</span>
                                                                    <DatePicker
                                                                        className={"form-control"}
                                                                        disabled={this.state.managedType === 'View more'}
                                                                        dateFormat={"dd-MMM-yyyy"}
                                                                        selected={this.state.updateExperienceData.endTime}
                                                                    />
                                                                </div>
                                                                <div className="col-md-5 selectlist">
                                                                    <span>Or</span>
                                                                    <input type="number"
                                                                           className="form-control custom-input"
                                                                           disabled={this.state.managedType === 'View more'}
                                                                           value={this.state.updateExperienceData.noOfDays}
                                                                           placeholder="No. of Days"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 privacywrap">
                                                        <div className="privacy">
                                                            <div className="custom-control custom-checkbox">
                                                                <input type="checkbox" className="custom-control-input"
                                                                       disabled={true}
                                                                       checked={this.state.updateExperienceData.agreeToTerms}
                                                                       id="agreement"/>
                                                                <label className="custom-control-label"
                                                                       htmlFor="agreement">I accept the
                                                                    WeNaturalists <strong>Terms & Conditions, User
                                                                        Agreement, Privacy Policy, and Cookie
                                                                        Policy</strong></label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                        <div className="formbottom">
                                            <button type="button" hidden={this.state.managedType === 'View more'}
                                                    onClick={this.updateProject} className="btn btn-primary">Continue
                                            </button>
                                            <button type="button" className="btn btn-cancel"
                                                    data-dismiss="modal">Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default OtherExperiencePopUp;

